import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import "./App.css";
import EmailPreferences from "./EmailPreferences";
import EmailPreferenceResetConfirmation from "./EmailPreferencesResetConfirmation";
import MigrationInfo from "./MigrationInfo";
import PasswordResetConfirmation from "./PasswordResetConfirmation";
import ResetPassword from "./ResetPassword";
import GetAgreements from "./UserAgreement";
import SubmitAgreements from "./UserAgreementsConfirmation";
import JoinPage from "./JoinPage";
import JoinSuccess from "./JoinSuccess";
import { finnTheme } from "./shared/theme";

function App() {
  return (
    <ThemeProvider theme={finnTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/accounts/passwordreset" element={<ResetPassword />} />
          <Route
            path="/accounts/passwordreset/success"
            element={<PasswordResetConfirmation />}
          />
          <Route
            path="/accounts/emailpreferences"
            element={<EmailPreferences />}
          />
          <Route
            path="/accounts/emailpreferences/success"
            element={<EmailPreferenceResetConfirmation />}
          />
          <Route
            path="/user/additional-agreements"
            element={<GetAgreements />}
          />
          <Route
            path="/user/additional-agreements/success"
            element={<SubmitAgreements />}
          />
          <Route path="/migration-info" element={<MigrationInfo />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/join/success" element={<JoinSuccess />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
